import React from "react";
import PropTypes from "prop-types";
import {
  ContentWithImage,
  Headline,
  Link,
  SectionContent,
  Text,
} from "../common";
import * as S from "./ComoUsar.Style";

const ComoUsar = (props) => {
  const {
    imgSrc,
    imgAlt,
    title,
    description,
    telefone,
    textAux,
    imgColumnSize,
  } = props;

  return (
    <SectionContent>
      <ContentWithImage
        imgColumnSize={imgColumnSize}
        imgSrc={imgSrc}
        imgAlt={imgAlt}
      >
        <Headline nivel="2" styleAs="5" text={title} />
        <S.ContentBody>
          <S.ImgMobile src={imgSrc} alt={imgAlt} />
          <div>
            {textAux && <Text>{textAux}</Text>}
            <S.TextDescription as={Text} textSize="sm">
              <strong>{description}</strong>
              <br />
              <S.Link
                as={Link}
                href={`tel:${telefone}`}
                textSize="xl"
                label={telefone}
              />
            </S.TextDescription>
          </div>
        </S.ContentBody>
      </ContentWithImage>
    </SectionContent>
  );
};

ComoUsar.defaultProps = {
  textAux: null,
  imgColumnSize: 4,
};
ComoUsar.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  telefone: PropTypes.string.isRequired,
  textAux: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  imgColumnSize: PropTypes.number,
};

export default ComoUsar;
